import axios from 'axios'

const API_URL = 'https://elana-api.herokuapp.com/api/individualOptions/'

const createIndividualOption = async(data)=>{
    const response = await axios.post(API_URL, data)

    if(response.data){
        console.log(response.data)
    }

    return response.data
}

const individualOptionsService = {
    createIndividualOption
}

export default individualOptionsService